import DiceModal from '../DiceModal'
import type { DiceGroup, DiceRollResult } from '@/types/dice'
import type { Character } from '@/types'
import type { SharedDiceModalState, SharedDiceRollingState } from './useDiceControls'

interface DiceControlsProps {
  tableId: string
  selectedCharacter?: Character | null
  /** Personagem do proprio usuario na mesa (o aluno nunca "seleciona" o dele:
   *  selectedCharacter so e preenchido pelo seletor de NPC, que e do mestre). */
  ownCharacter?: Character | null
  rollDice: (diceType: any, characterId?: string, sessionId?: string, attributeId?: string, dice?: DiceGroup[], attributeIds?: string[]) => Promise<DiceRollResult | null>
  showDiceModal: boolean
  sharedDiceModal: SharedDiceModalState
  /** A rolagem em curso/congelada na mesa — para a bandeja de todos animar. */
  sharedDiceRolling: SharedDiceRollingState
  /** O mestre valida a jogada (ou pede para repetir) direto da bandeja. */
  souMestre?: boolean
  /** Ha mestre com socket vivo na mesa? Sem ele o servidor recusa a rolagem. */
  mestreOnline?: boolean
  /** Jogada que o mestre mandou repetir: a bandeja volta a montagem. */
  repetida?: string | null
  onDiceModalClose: () => void
  onSharedDiceModalCloseRequest: () => void
}

export function DiceControls({
  tableId,
  selectedCharacter,
  ownCharacter,
  rollDice,
  showDiceModal,
  sharedDiceModal,
  sharedDiceRolling,
  souMestre = false,
  mestreOnline = true,
  repetida = null,
  onDiceModalClose,
  onSharedDiceModalCloseRequest
}: DiceControlsProps) {
  // Mestre falando como NPC testa a ficha do NPC; qualquer outro testa a sua.
  const fichaDoTeste = selectedCharacter ?? ownCharacter

  // So a rolagem DESTA sessao anima a bandeja espelhada: uma rolagem de
  // terceiros (despachada do historico, por exemplo) nao invade a tela.
  //
  // `isActive` e obrigatorio: publicada, a jogada e ENCERRADA (isActive
  // false), mas o estado guarda o resultado como residuo. Sem esta condicao,
  // o mesmo jogador reabrindo o modal fazia a mesa rever a jogada anterior
  // congelada, com botao de envio e tudo (bug relatado pelo Paulo,
  // 2026-07-26: comparar so o userId deixa Isaac passar por Isaac).
  const aoVivoDaSessao =
    sharedDiceModal.isOpen
    && sharedDiceRolling.isActive
    && sharedDiceRolling.userId
    && sharedDiceRolling.userId === sharedDiceModal.roller.userId
      ? sharedDiceRolling
      : undefined

  return (
    <>
      {/* Modal de Dados */}
      {tableId && (
        <DiceModal
          isOpen={sharedDiceModal.isOpen || showDiceModal}
          onClose={sharedDiceModal.isOpen ? onSharedDiceModalCloseRequest : onDiceModalClose}
          tableId={tableId}
          characterId={selectedCharacter?.id}
          testCharacterId={fichaDoTeste?.id}
          testCharacterAttributes={fichaDoTeste?.attributes}
          onRollDice={rollDice}
          isShared={sharedDiceModal.isOpen}
          canInteract={sharedDiceModal.canInteract}
          rollerName={sharedDiceModal.roller.userName || sharedDiceModal.roller.characterName}
          sessionId={sharedDiceModal.isOpen ? sharedDiceModal.sessionId : undefined}
          sharedTest={sharedDiceModal.isOpen ? sharedDiceModal.teste : undefined}
          montagem={sharedDiceModal.montagem}
          aoVivo={aoVivoDaSessao}
          souMestre={souMestre}
          mestreOnline={mestreOnline}
          repetida={repetida}
        />
      )}
    </>
  )
}
